import React from 'react';
import Loadable from 'react-loadable';

import Loader from '../../utils/Loader';
import AuthenticatedLayout from '../Layouts/Authenticated';
import { ADVANCE_PAYMENT_GUARANTEE, PERFORMANCE_GUARANTEE } from './config';

const List = Loadable({
    loader: () => import('./list' /* webpackChunkName: "Contract-guarantees" */),
    loading() {
        return <Loader />;
    },
});

const Wizard = Loadable({
    loader: () => import('./create' /* webpackChunkName: "Contract-guarantees" */),
    loading() {
        return <Loader />;
    },
});

const Detail = Loadable({
    loader: () => import('./detail' /* webpackChunkName: "Contract-guarantees" */),
    loading() {
        return <Loader />;
    },
});

export const PerformanceGuaranteesComponent = () => (
    <AuthenticatedLayout>
        <List config={PERFORMANCE_GUARANTEE} />
    </AuthenticatedLayout>
);

export const NewPerformanceGuaranteeComponent = () => <Wizard config={PERFORMANCE_GUARANTEE} />;

export const EditPerformanceGuaranteeComponent = () => <Wizard config={PERFORMANCE_GUARANTEE} edit />;

export const ViewPerformanceGuaranteeComponent = () => (
    <AuthenticatedLayout>
        <Detail config={PERFORMANCE_GUARANTEE} />
    </AuthenticatedLayout>
);

export const AdvancePaymentGuaranteesComponent = () => (
    <AuthenticatedLayout>
        <List config={ADVANCE_PAYMENT_GUARANTEE} />
    </AuthenticatedLayout>
);

export const NewAdvancePaymentGuaranteeComponent = () => <Wizard config={ADVANCE_PAYMENT_GUARANTEE} />;

export const EditAdvancePaymentGuaranteeComponent = () => <Wizard config={ADVANCE_PAYMENT_GUARANTEE} edit />;

export const ViewAdvancePaymentGuaranteeComponent = () => (
    <AuthenticatedLayout>
        <Detail config={ADVANCE_PAYMENT_GUARANTEE} />
    </AuthenticatedLayout>
);
